import React from 'react';
import magnifyingGlass from '../../../../images/icons/magnifying-glass.svg';
import chevronDown from '../../../../images/icons/chevron-down.svg';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const CustomDropdownIndicator = props => {
  const { type } = props;
  return (
    <components.DropdownIndicator {...props}>
      {type === 'glass' && <img src={magnifyingGlass} alt="search" width="16px" />}
      {type === 'arrow' && <img src={chevronDown} alt="search" width="16px" />}
    </components.DropdownIndicator>
  );
};

CustomDropdownIndicator.propTypes = {
  type: PropTypes.string,
};

CustomDropdownIndicator.defaultProps = {
  type: 'arrow',
};

export default CustomDropdownIndicator;
